import {
  addDays,
  subDays,
  addWeeks,
  subWeeks,
  addMonths,
  subMonths,
  addYears,
  subYears,
  format,
  startOfDay,
} from 'date-fns';

export type DateRangeDirection = 'before' | 'after' | 'both';
export type DateRangeUnit = 'day' | 'week' | 'month' | 'year';

/** 日付文字列を YYYY-MM-DD に正規化（datetime の場合は日付部分のみ） */
export function normalizeDateToYYYYMMDD(date: string): string {
  if (!date || typeof date !== 'string') return '';
  const s = date.trim();
  return s.includes('T') ? s.slice(0, 10) : s;
}

/**
 * 中心日と「前・後・前後」＋数値＋単位から、範囲の開始日・終了日（inclusive）を算出する。
 * 方向デフォルト: 前後 / 数値デフォルト: 0（その日のみ）/ 単位デフォルト: 日
 */
export function computeDateRange(
  center: string,
  direction: DateRangeDirection,
  value: number,
  unit: DateRangeUnit
): { start: string; end: string } | null {
  const trimmed = normalizeDateToYYYYMMDD(center);
  if (!trimmed) return null;
  const c = startOfDay(new Date(trimmed + 'T00:00:00'));
  if (Number.isNaN(c.getTime())) return null;
  const v = Math.max(0, Math.floor(value));

  const offsetByUnit = (d: Date, n: number, add: boolean): Date => {
    if (unit === 'week') return add ? addWeeks(d, n) : subWeeks(d, n);
    if (unit === 'month') return add ? addMonths(d, n) : subMonths(d, n);
    if (unit === 'year') return add ? addYears(d, n) : subYears(d, n);
    return add ? addDays(d, n) : subDays(d, n);
  };

  const start =
    direction === 'both' || direction === 'before' ? offsetByUnit(c, v, false) : c;
  const end =
    direction === 'both' || direction === 'after' ? offsetByUnit(c, v, true) : c;

  return {
    start: format(start, 'yyyy-MM-dd'),
    end: format(end, 'yyyy-MM-dd'),
  };
}
